import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import Card from "@irati/ui/src/Layout/Card"
import {Body, H3} from "@irati/ui/src/Typography"
import {CheckoutRedemption, Deal} from "@irati/types"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import OrderSummary from "../SuccessOrderSummary"
import DealSuccessTickets from "../../Tickets/Tickets"
import {CashbackRedemptionWrapper, IconWrapper, RedemptionInstructionsWrapper, TicketWrapper} from "./styled"

interface Props {
  deal: Deal
  vouchers: any[]
  redemption: CheckoutRedemption
}

const CashbackRedemptionSuccess: FC<Props> = ({deal, redemption, vouchers}) => {
  const {formatMessage} = useIntl()

  return (
    <CashbackRedemptionWrapper>
      <TicketWrapper>
        <DealSuccessTickets deal={deal} redemption={redemption} vouchers={vouchers}>
          <OrderSummary order={redemption.order} />
        </DealSuccessTickets>
      </TicketWrapper>
      <RedemptionInstructionsWrapper>
        <Card padding={3}>
          <Flex direction="column" gap={3}>
            <H3 textAlign="center">
              <FormattedMessage id="perks.components.cashbackRedemptionInstructions.header" />
            </H3>
            <Flex gap={1.5}>
              <IconWrapper>📱</IconWrapper>
              <Body small>
                <FormattedMessage id="perks.components.cashbackRedemptionInstructions.instructions.labelOne" />
              </Body>
            </Flex>
            <Flex gap={1.5}>
              <IconWrapper>🚫</IconWrapper>
              <Body small>
                <FormattedMessage id="perks.components.cashbackRedemptionInstructions.instructions.labelTwo" />
              </Body>
            </Flex>
            <Flex gap={1.5}>
              <IconWrapper>🔗</IconWrapper>
              <Body small>
                <FormattedMessage id="perks.components.cashbackRedemptionInstructions.instructions.labelThree" />
              </Body>
            </Flex>
            <Flex gap={1.5}>
              <IconWrapper>❌</IconWrapper>
              <Body small>
                <FormattedMessage id="perks.components.cashbackRedemptionInstructions.instructions.labelFour" />
              </Body>
            </Flex>

            <Alert
              nonDismissable
              type={AlertTypes.info}
              title="perks.components.cashbackRedemptionInstructions.alert.title"
              subTitle={
                deal.cashbackETADays
                  ? formatMessage({id: "perks.components.cashbackRedemptionInstructions.alert.subTitleTwo"}, {count: deal.cashbackETADays})
                  : formatMessage({id: "perks.components.cashbackRedemptionInstructions.alert.subTitleZeroDays"})
              }
            />
          </Flex>
        </Card>
      </RedemptionInstructionsWrapper>
    </CashbackRedemptionWrapper>
  )
}

export default CashbackRedemptionSuccess
